const { default: axios } = require("axios");
import Swal from 'sweetalert2';
import $ from 'jquery';
import moment from 'moment';
import * as _ from 'lodash'

document.querySelector('#reportsPage') && new Vue({
    el: '#reportsPage',
    data() {
        return {
            filters: {
                start_date: moment().format("YYYY-MM-DD"),
                end_date: moment().format("YYYY-MM-DD"),
                office_id: '',
                fuel_type: '',
                status: '',
            },
            isLoading: false,
            gas_requests: []
        }
    },
    mounted() {
        this.generateReport();
    },
    computed: {
        selectedOffice() {
            if (this.filters.office_id == '') {
                return null;
            }

            return offices.find(o => o.id == this.filters.office_id);
        },
        selectedFuelType() {
            if (this.filters.fuel_type == '') {
                return null;
            }

            return fuel_types.find(o => o.id == this.filters.fuel_type);
        }
    },
    methods: {
        generateReport: _.debounce(function () {
            console.log(this.selectedOffice)
            console.log(this.selectedFuelType)
            axios.get(`${window.location.pathname}/create`, { params: this.filters }).then((response) => {
                this.gas_requests = response.data;
                this.isLoading = false;
                console.log(this.gas_requests)
            });
        }, 3000),
        loadReport() {
            this.gas_requests = [];
            this.isLoading = true;
            this.generateReport();
        },
        exportReport() {
            let params = new URLSearchParams(this.filters).toString();
            console.log(window.location)
            window.location.href = `${window.location.pathname.replace("reports", "report")}/export?${params}`;
        }
    },
    filters: {
        parseDate(value, format = "LLL") {
            return value ? moment(value).format(format) : '-';
        }
    }
});